export default __webpack_public_path__ + "static/media/gallery_04.4d7a856e.jpg";